import { render, staticRenderFns } from "./r-league-config-dialog.vue?vue&type=template&id=358258ae"
import script from "./r-league-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-league-config-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358258ae')) {
      api.createRecord('358258ae', component.options)
    } else {
      api.reload('358258ae', component.options)
    }
    module.hot.accept("./r-league-config-dialog.vue?vue&type=template&id=358258ae", function () {
      api.rerender('358258ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/leaderboard/r-league-config-dialog.vue"
export default component.exports